import React, { useState, useEffect } from 'react';
import "./App.css";
import contract from './ABI';
import contractERC20 from "./ERC20ABI";
import Web3 from "web3";

const App = () => {
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(0);

  useEffect(() => {
    async function checkNetwork() {
      // Modern dApp browsers should have window.ethereum available
      if (window.ethereum) {
        const web3 = new Web3(window.ethereum);
        try {
          // Get the current network ID from the Ethereum provider
          const networkId = await web3.eth.net.getId();
          if (networkId != 56) {
            alert("You need to be on binance smart chain mainnet")
          } else {
            contract.methods.totalSupply().call().then((supply) => {
              if (supply < 20) {
                setPrice(100);
            } else if (supply < 100) {
                setPrice(150);
            } else {
                setPrice(200)
            }
            })
          }
        } catch (error) {
          console.error('Error fetching network:', error);
        }
      }
    }

    checkNetwork();
  }, []);

  const connectWallet = async () => {
    try {
      setLoading(true);
      if (window.ethereum) {
        const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });

        if (accounts.length > 0) {
          setLoading(false);
          return accounts[0];
        } else {
          setLoading(false);
          console.error('No accounts found in MetaMask. Please make sure you have at least one account connected.');
          return null;
        }
      } else {
        setLoading(false);
        console.error('Please install MetaMask to use this application.');
        return null;
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      console.error('Error connecting to MetaMask. Please try again or check your MetaMask extension.');
      return null;
    }
  };

  const mintToken = async () => {
    const account = await connectWallet();
    if (!account) return;

    if (account === '') {
      console.error('Please connect your MetaMask wallet to mint a Zoin token.');
      return;
    }
    

    try {
      setLoading(true);
      const approvalAmount = (150n * 10n**18n).toString();
      console.log(approvalAmount);
      await contractERC20.methods.approve(contract.options.address, approvalAmount).send({ from: account });
      await contract.methods.mint().send({ from: account, value: 0 });
      setLoading(false);
      console.error('NFT minted successfully.');
    } catch (error) {
      console.error(error);
      setLoading(false);
      console.error('Error minting NFT.');
    }
  };

  return (
    <div className="centered-container">
      <div className="minting-page">
        <img alt="NFT" src="./Zoin.png"></img>
        <h1 className="gold">Mint Your Zoin NFT</h1>
        <p>Earn indefinent passive income for just {price ? price : "100"} USDC.</p>
        <button onClick={mintToken} disabled={loading}>
          Mint
        </button>
      </div>
    </div>
  );
};

export default App;
